<div class="img-view">
    <img [src]="data['imgUploaded']">
</div>
